"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var reviewChanges_svg_1 = __importDefault(require("@src/components/Icon/reviewChanges.svg"));
require("./ReviewChangesModal.scss");
var defaults = {
    modalActive: false,
    closeModal: function () { return null; },
    onTransferClick: function () { return null; },
    onPreviewClick: function () { },
};
var ReviewChangesModal = function (_a) {
    var _b = _a === void 0 ? defaults : _a, modalActive = _b.modalActive, closeModal = _b.closeModal, onTransferClick = _b.onTransferClick, onPreviewClick = _b.onPreviewClick;
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "", subtitle: "", headerIcon: null, headerSubIcon: null, active: modalActive, classPrefix: "reviewModal", isV2: true, toggleModal: function () { return closeModal(); } },
        react_1["default"].createElement(icon_1["default"], { src: reviewChanges_svg_1["default"], className: "reviewIcon" }),
        react_1["default"].createElement("div", { className: "reviewModalBody" },
            react_1["default"].createElement(text_1["default"], { className: "reviewModalBodyTitle", variant: "h2.semi-bold" }, "Wait, more changes have been added to the log!"),
            react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" }, "Click on Refresh Preview to see the new changes made by other bot builders that'll ship with your transfer."),
            react_1["default"].createElement(box_1["default"], { p: "0", pt: 32 },
                react_1["default"].createElement(button_1["default"], { onClick: onTransferClick, className: "transferBtn", size: "large", type: "text", variant: "secondary", themed: true }, "Publish Anyway"),
                react_1["default"].createElement(button_1["default"], { onClick: onPreviewClick, size: "large", type: "text", themed: true }, "Refresh Preview")))));
};
exports["default"] = ReviewChangesModal;
